import { render, staticRenderFns } from "./advertising1.vue?vue&type=template&id=50dabb13&scoped=true"
import script from "./advertising1.vue?vue&type=script&lang=js"
export * from "./advertising1.vue?vue&type=script&lang=js"
import style0 from "./advertising1.vue?vue&type=style&index=0&id=50dabb13&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dabb13",
  null
  
)

export default component.exports